var exports = {
  "zY": "signInDialog__SaI_3_",
  "Ye": "dialogLogo__GpmFhg",
  "zc": "iconContainer__fB_0v_",
  "NV": "signInTitle__wmrIaN",
  "Cu": "signInText__HCVl-2",
  "UD": "buttonContainer__ffxDDw",
};

module.exports = exports;
